import { ApiUrl } from '../app/Config';

define(['backbone', 'models/FillProvider'], function(
  Backbone,
  FillProviderModel
) {
  return Backbone.Collection.extend({
    url: ApiUrl + 'FillProviders',
    model: FillProviderModel,
    getName: function(providerId) {
      if (!providerId) return '';
      var m = this.get(providerId);
      if (!m) return '???';
      return m.get('Name');
    },
    parse: function(resp) {
      return resp.shipping;
    }
  });
});
